import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';



import { UploadFileInfoModel } from './upload-file-info.model';

@Component({
    selector: 'kh-text-editor-file-upload-modal',
    styleUrls: ['./text-editor-file-upload-modal.component.less'],
    templateUrl: './text-editor-file-upload-modal.component.html',
    standalone: false
})
export class TextEditorFileUploadModalComponent {
  public form = this.initForm();
  @Output() public closed = new EventEmitter<UploadFileInfoModel | null>();
  @Output() public chooseSource = new EventEmitter<void>();

  public constructor(private readonly formBuilder: FormBuilder) {}

  @Input()
  public set sourceImage(image: UploadFileInfoModel) {
    if (image) {
      this.form.setValue(image);
    }
  }

  public showChooseSourceModal(): void {
    this.chooseSource.emit();
  }

  public submitForm({ value }: FormGroup): void {
    const uploadFileInfo = value as UploadFileInfoModel;
    this.closed.emit(uploadFileInfo.src ? uploadFileInfo : null);
  }

  public closeModal(): void {
    this.closed.emit();
  }

  private initForm(): FormGroup {
    return this.formBuilder.group({
      alt: '',
      constrain: true,
      height: '',
      src: '',
      width: ''
    });
  }
}
